const GET_PROFILE = 'react-template/persons/GET_PROFILE'
const GET_PROFILE_SUCCESS = 'react-template/persons/GET_PROFILE_SUCCESS'
const GET_PROFILE_FAIL = 'react-template/persons/GET_PROFILE_FAIL'

const UPDATE_PROFILE = 'react-template/persons/UPDATE_PROFILE'
const UPDATE_PROFILE_SUCCESS = 'react-template/persons/UPDATE_PROFILE_SUCCESS'
const UPDATE_PROFILE_FAIL = 'react-template/persons/UPDATE_PROFILE_FAIL'

const CHANGE_EMAIL = 'react-template/persons/CHANGE_EMAIL'
const CHANGE_EMAIL_SUCCESS = 'react-template/persons/CHANGE_EMAIL_SUCCESS'
const CHANGE_EMAIL_FAIL = 'react-template/persons/CHANGE_EMAIL_FAIL'

const LOGIN_CHANGE = 'react-template/persons/LOGIN_CHANGE'
const LOGIN_CHANGE_SUCCESS = 'react-template/persons/LOGIN_CHANGE_SUCCESS'
const LOGIN_CHANGE_FAIL = 'react-template/persons/LOGIN_CHANGE_FAIL'

const EDIT_PERSON_LOCALE = 'dofe/persons/EDIT_PERSON_LOCALE'
const EDIT_PERSON_LOCALE_SUCCESS = 'dofe/persons/EDIT_PERSON_LOCALE_SUCCESS'
const EDIT_PERSON_LOCALE_FAIL = 'dofe/persons/EDIT_PERSON_LOCALE_FAIL'

const initialState = {
  profile: {
    loaded: false,
    data: null
  }
}

export default function persons(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PROFILE:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: true
        }
      }

    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: false,
          loaded: true,
          error: null,
          data: action.result
        }
      }

    case GET_PROFILE_FAIL:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case UPDATE_PROFILE:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: true
        }
      }

    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case CHANGE_EMAIL:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: true
        }
      }

    case CHANGE_EMAIL_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case CHANGE_EMAIL_FAIL:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    default:
      return state
  }
}

export function loadProfile(options = {}) {
  let readParams = 'CONTACTS,PARTICIPANT_REGISTRATION,ORGANIZATION'

  if (options.isAssessor) {
    readParams = 'ADDRESS,CONTACTS,PARTICIPANT_REGISTRATION,ASSESSOR_DETAILS'
  }

  return {
    types: [GET_PROFILE, GET_PROFILE_SUCCESS, GET_PROFILE_FAIL],
    promise: client => client.get(`api/persons/profile?with=${readParams}`)
  }
}

export function editProfile(
  personId,
  data,
  updateParams = ['CONTACT'],
  options = {}
) {
  if (options.isAssessor) {
    updateParams = updateParams.concat('ADDRESS', 'ASSESSOR_DETAILS', 'ASSESSOR_PERSONAL_DETAILS')
  }
  console.log('wtf', updateParams)

  return {
    types: [UPDATE_PROFILE, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_FAIL],
    promise: client =>
      client.put(`api/persons/${personId}?awardLeaderId=0&update=${updateParams.join(',')}`, {
        data
      })
  }
}

export function editPersonLocale(personId, data) {
  return {
    types: [
      EDIT_PERSON_LOCALE,
      EDIT_PERSON_LOCALE_SUCCESS,
      EDIT_PERSON_LOCALE_FAIL
    ],
    promise: client =>
      client.put(`api/persons/${personId}?awardLeaderId=0&update=LOCALE`, {
        data
      })
  }
}

export function changePassword(personId, data) {
  return {
    types: [UPDATE_PROFILE, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_FAIL],
    promise: client =>
      client.post(`api/persons/${personId}/password-change`, { data })
  }
}

export function editProfilePhoto(personId, data) {
  return {
    types: [UPDATE_PROFILE, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_FAIL],
    promise: client =>
      client.post(`api/persons/${personId}/profilePhoto`, {
        data,
        formData: true
      })
  }
}

export function changeEmail(personId, data) {
  return {
    types: [CHANGE_EMAIL, CHANGE_EMAIL_SUCCESS, CHANGE_EMAIL_FAIL],
    promise: client =>
      client.post(`api/persons/${personId}/login-change-request`, {
        data
      })
  }
}

export function changeAssessorEmail(personId, data) {
  return {
    types: [CHANGE_EMAIL, CHANGE_EMAIL_SUCCESS, CHANGE_EMAIL_FAIL],
    promise: client =>
      client.post(`api/persons/${personId}/login-change`, {
        data
      })
  }
}

export function loginChange(personId, authorizationCode) {
  return {
    types: [LOGIN_CHANGE, LOGIN_CHANGE_SUCCESS, LOGIN_CHANGE_FAIL],
    promise: client =>
      client.post(
        `api/persons/${
          personId
        }/login-change-using-authorization-code?authorizationCode=${
          authorizationCode
        }`,
        {
          removeToken: true
        }
      )
  }
}

export function deleteProfilePhoto(personId) {
  return {
    types: [UPDATE_PROFILE, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_FAIL],
    promise: client => client.del(`api/persons/${personId}/profilePhoto`)
  }
}
